import React from "react";
import {
  Button,
  Center,
  Box,
  VStack,
  Container,
  Image,
  Heading,
  Icon,
  useBoolean,
} from "@chakra-ui/react";
import useTranslate from "hooks/useTranslate";
import { useConnect } from "wagmi";
import Logo from "components/Logo";
import useSnackbarRpcError from "hooks/useSnackbarRpcError";
import { publicUrl, v1Name, v2Name } from "config";
import ReserveProcessContainer from "components/ReserveProcessContainer";
import Panel from "components/Panel";
import { FaPlayCircle } from "react-icons/fa";
import HowItWorksPopup from "components/HowItWorksPopup";

const ConnectPage: React.FC = () => {
  const translate = useTranslate();
  const [{ data: connectData, error }, connect] = useConnect();
  const [isVideoPopupOpen, setIsVideoPopupOpen] = useBoolean(false);

  useSnackbarRpcError(error);

  return (
    <>
      <Container flexGrow="1">
        <Center pt="12" pb="20" h="full">
          <VStack w="full" maxW="sm" align="center" spacing="6">
            <Box as={Logo} w="40" h="auto" flexShrink="0" />

            <VStack
              spacing="3"
              role="button"
              cursor="pointer"
              onClick={setIsVideoPopupOpen.on}
            >
              <Center flexDir="column" textAlign="center">
                <Image
                  src={`${publicUrl}/connect-illustration.png`}
                  w="full"
                  maxW="20em"
                />
              </Center>

              <VStack
                spacing="2"
                role="button"
                cursor="pointer"
                onClick={setIsVideoPopupOpen.on}
              >
                <Icon as={FaPlayCircle} color="bright.50" w="12" h="12" />
                <Heading fontSize="lg" maxW="16em" textAlign="center">
                  {translate("connect:video:trigger")}
                </Heading>
              </VStack>
            </VStack>

            <VStack w="full" align="stretch" spacing="4" flexShrink="0">
              {connectData.connectors.map((connector) => (
                <Button
                  key={connector.id}
                  onClick={() => connect(connector)}
                  isDisabled={!connector.ready}
                  size="lg"
                >
                  {translate("connect:button:label", {
                    connector:
                      connector.name === "Injected"
                        ? "MetaMask"
                        : connector.name,
                  })}
                </Button>
              ))}
            </VStack>

            <Panel px="6" py="6" textAlign="center">
              <Heading size="sm" mb="4" lineHeight="base">
                {translate("connect:reserve:info", {
                  v1Name,
                  v2Name,
                })}
              </Heading>

              <ReserveProcessContainer
                trigger={
                  <Button size="sm" colorScheme="dark">
                    {translate("connect:reserve:trigger", { v2Name })}
                  </Button>
                }
              />
            </Panel>
          </VStack>
        </Center>
      </Container>

      <HowItWorksPopup
        isOpen={isVideoPopupOpen}
        onClose={setIsVideoPopupOpen.off}
      />
    </>
  );
};

export default ConnectPage;
